export const ScormMixin = {
    data() {
        return {
            scorm: null,
            spData: Object(),
        }
    },
    methods: {
        scorm_init() {
            //Specify SCORM 1.2:
            this.scorm = pipwerks.SCORM;
            this.scorm.version = "1.2";
            var callSucceeded = this.scorm.init();
            this.sp_loadSuspendData();
        },

        scorm_setSuspendData(value) {
            var result = this.scorm_set("cmi.suspend_data", value);
            return result;
        },

        scorm_getSuspendData() {
            return this.scorm_get("cmi.suspend_data");
        },
        scorm_set(param, value) {
            var callSucceeded = this.scorm.set(param, value);
            this.scorm.data.save();
            return callSucceeded;
        },
        scorm_get(param) {
            var value = this.scorm.get(param);
            return value;
        },
        scorm_complete() {
            var callSucceeded = this.scorm.set("cmi.core.lesson_status","completed"
            );
            this.scorm.data.save();
        },
        scorm_score(mScore) {
            var callSucceeded = this.scorm.set("cmi.core.score.raw", mScore);
            this.scorm.data.save();
        },
        scorm_end() {
            var callSucceeded = this.scorm.quit();
        },

        // Supsend data methods
        sp_setVariable(name, value) {
            this.spData[name] = value;
            this.sp_saveScorm();
        },

        sp_getVariable(name) {
            return this.spData[name];
        },

        sp_saveScorm() {
            var saveString = JSON.stringify(this.spData);
            if (this.useLocalStorage) {
                localStorage.setItem(this.localStorageName, saveString);
            } else {
                this.scorm_setSuspendData(saveString);
            }
        },

        sp_loadSuspendData() {
            var lmsData = this.scorm_getSuspendData();
            var lsData;
            var result;
            // useLocalStorage should be defined in the component that imports this mixin
            if (lmsData == "null") {
                if (this.useLocalStorage) {
                    lsData = localStorage.getItem(this.localStorageName);
                    if (lsData == null) {
                        result = Object();
                    } else {
                        result = lsData;
                        result = JSON.parse(lsData);
                    }
                } else {
                    result = Object();
                }
            } else {
                if (lmsData != undefined && lmsData != "") {
                    result = JSON.parse(lmsData);
                } else {
                    result = Object();
                }
            }
            this.spData = result;
        }
    }
};